import styled from 'styled-components';
import { Section } from '../../Common/PageElement';
import { MD_FONT_SIZE, PRIMARY_COLOR, SECONDARY_COLOR, SEMI_FONT_WEIGHT, SM_FONT_SIZE, SM_PADDING, WHITE_COLOR } from '../../Common/StyleElement';


export const CiteSection = styled.section`
    font-size: 15px;
    display: flex;
    ${(props) =>
    props.center
        ? `justify-content: center;
            align-items: center;
            `
        : `padding: 120px 0;`}
`;

export const FeatureSection = styled(CiteSection)`
    background-color: ${PRIMARY_COLOR};
    color: ${WHITE_COLOR};
    border-top: 100px;

`